import { render, staticRenderFns } from "./CWHeader.vue?vue&type=template&id=47808f26&scoped=true&"
import script from "./CWHeader.vue?vue&type=script&lang=js&"
export * from "./CWHeader.vue?vue&type=script&lang=js&"
import style0 from "./CWHeader.vue?vue&type=style&index=0&id=47808f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47808f26",
  null
  
)

export default component.exports